// extracted by mini-css-extract-plugin
export var errorsContainer = "_sy-1";
export var link = "_sy-0";